

import api from '@/utils/api';
import { LiveApi } from './interface';
import { liveBot } from './bot';

const liveApi: LiveApi = {
    getLiveToken: (roomId) => api.get(`/glive2-cloud-gateway/api/v1/live/getToken/${roomId}`),
    getUserInfo: (params) => api.post('/glive2-cloud-gateway/api/v1/live/room/loginAuth', params),
    getRoomInfo:(roomId) => api.get(`/glive2-cloud-gateway/api/v1/live/room/description/${roomId}`),
    getUserRoomInfo:(roomId) => api.get(`/glive2-cloud-gateway/api/v1/live/interact/paas/getRoomStatusInfo/${roomId}`),
    getGroupList: (roomId) => api.get(`/glive2-cloud-gateway/api/v1/live/groups/query/${roomId}`),
    getStudentList: (params) => api.get('/glive2-cloud-gateway/api/v1/live/interact/paas/getOnlineUserList', params),
    getHistoryChatList:(params) => api.get('/glive2-cloud-gateway/api/v1/live/interact/paas/queryChatList', params),
    getHistoryQAList: (params) => api.get('/glive2-cloud-gateway/api/v1/live/interact/paas/queryQuestionList', params),
    getSeekHelpConfig: () => api.get('/glive2-cloud-gateway/api/v1/live/interact/getPaasSeekhelpConfig'),
    submitSeekHelp: (params) => api.post('/glive2-cloud-gateway/api/v1/live/interact/studentSeekhelp', params),
    applyFileTranscode: (params) => api.post('/glive2-cloud-gateway/api/v1/live/handout/import', params),
    onTransCodeProgress: (params) => api.post('/glive2-cloud-gateway/api/v1/live/room/wb/transcode/query', params),
    getOnlineUserCount: (params: any) => api.get(`/glive2-cloud-gateway/api/v1/live/interact/paas/getOnlineUserCount/${params.roomId}`, params.roleType?{roleType: params.roleType}:{}),
    getTeacherList: (params) => api.get(`/glive2-cloud-gateway/api/v1/live/interact/paas/getOnlineTeacherList`, params),
    uploadFile: (params) => api.upload(`/glive2-cloud-gateway/api/v1/live/handout/upload`, params),
    getRoomAgilityStatusInfo: (roomId) => api.get(`/glive2-cloud-gateway/api/v1/live/interact/paas/getRoomAgilityStatusInfo/${roomId}`),
    getUserAnswerList: (params) => api.get(`/glive2-cloud-gateway/api/v1/live/interact/exercise/userAnswerList`, params),
}

export default window.location.hash.includes('record') ?  liveBot : liveApi;
// export default liveApi;
